import { render, staticRenderFns } from "./ComplexesPage.vue?vue&type=template&id=3cb7f854&scoped=true&lang=pug&"
import script from "./ComplexesPage.vue?vue&type=script&lang=js&"
export * from "./ComplexesPage.vue?vue&type=script&lang=js&"
import style0 from "./ComplexesPage.vue?vue&type=style&index=0&id=3cb7f854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb7f854",
  null
  
)

export default component.exports